// #region Inline Bootstrap Loader
(g) => {
    const p = "The Google Maps JavaScript API";
    const c = "google";
    const l = "importLibrary";
    const q = "__ib__";
    const m = document;
    const b = window;
    b[c] = b[c] || {};
    const d = b[c].maps || (b[c].maps = {});
    const r = new Set();
    const e = new URLSearchParams();

    let h, a;
    const loadScript = () => {
        if (h) return h;
        h = new Promise((resolve, reject) => {
            a = m.createElement("script");
            e.set("libraries", [...r].join(","));
            Object.keys(g).forEach((k) => {
                e.set(
                    k.replace(/ [A-Z]/g, (t) => "_" + t[0].toLowerCase()),
                    g[k]
                );
            });
            e.set("callback", `${c}.maps.${q}`);
            a.src = `https://maps.${c}apis.com/maps/api/js?` + e;
            d[q] = resolve;
            a.onerror = () => reject(new Error(`${p} could not load.`));
            a.nonce = m.querySelector("script[nonce]")?.nonce || "";
            m.head.append(a);
        });
        return h;
    };

    d[l]
        ? console.warn(`${p} only loads once. Ignoring:`, g)
        : (d[l] = (f, ...n) =>
              r.add(f) && loadScript().then(() => d[l](f, ...n)));
};
// #endregion

// To load libraries at runtime, use the await operator to call importLibrary() from within an async function
async function initMap(mapElement) {
    // Import the necessary modules from Google Maps
    const { Map } = await google.maps.importLibrary("maps");

    // The 'Marker' and 'Circle' come from the 'maps' namespace
    const { Marker, Circle } = google.maps;

    const { lat, lng, exact, zoom, style, marker } = mapElement.dataset;

    const latitude = parseFloat(lat);
    const longitude = parseFloat(lng);
    const isExact = exact === "1";
    const mapZoom = parseFloat(zoom);
    const mapStyle = style ? JSON.parse(style) : [];
    const mapMarker = marker;

    const mapOptions = {
        // Map Positioning and Zoom
        center: { lat: latitude, lng: longitude }, // Default: { lat: 0, lng: 0 }
        zoom: mapZoom, // Default: 8
        // minZoom: undefined, // Default: undefined (no minimum zoom)
        // maxZoom: undefined, // Default: undefined (no maximum zoom)

        // // Controls
        zoomControl: true, // Default: true
        // zoomControlOptions: undefined, // Default: undefined (no custom options)
        // mapTypeControl: true, // Default: true
        // mapTypeControlOptions: undefined, // Default: undefined (no custom options)
        // streetViewControl: true, // Default: true
        // streetViewControlOptions: undefined, // Default: undefined (no custom options)
        // fullscreenControl: true, // Default: true
        // fullscreenControlOptions: undefined, // Default: undefined (no custom options)
        // scaleControl: false, // Default: false
        // scaleControlOptions: undefined, // Default: undefined (no custom options)

        // // Interaction
        scrollwheel: false, // Default: true (scroll to zoom)
        // disableDoubleClickZoom: true, // Default: true (double-click zoom disabled)
        // draggable: true, // Default: true (map is draggable)
        // draggableCursor: undefined, // Default: undefined (default cursor)
        // draggingCursor: undefined, // Default: undefined (default dragging cursor)
        // keyboardShortcuts: true, // Default: true (keyboard shortcuts enabled)
        // gestureHandling: "auto", // Default: "auto" (gestures work normally)
        // clickableIcons: true, // Default: true (points of interest clickable)

        // // Map Type and Styling
        // mapTypeId: "roadmap", // Default: "roadmap" (can be "satellite", "hybrid", "terrain")
        // backgroundColor: "#e5e3df", // Default: "#e5e3df" (background color before tiles load)
        // noClear: false, // Default: false (map will be cleared when new map is created)
        styles: mapStyle, // Default: undefined (no custom styles)

        // // Customization
        // disableDefaultUI: false, // Default: false (default UI controls are enabled)
        // controlSize: 26, // Default: 26 (size of controls in pixels)

        // // Views and Overlays
        // overviewMapControl: false, // Default: false (overview map not shown)
        // overviewMapControlOptions: undefined, // Default: undefined (no custom options)
        // rotateControl: true, // Default: true (allows rotating map in 45° imagery)
        // rotateControlOptions: undefined, // Default: undefined (no custom options)
        // panControl: false, // Default: false (pan control not shown)

        // // Custom Feature Behavior
        // restriction: undefined, // Default: undefined (no bounds restrictions)
        // tilt: 0, // Default: 0 (tilt is flat, 45 for 45° imagery)
        // heading: 0, // Default: 0 (north is up)
        // mapId: undefined, // Default: undefined (no custom map ID)

        // // Advanced Options
        // mapTypeIds: undefined, // Default: undefined (no additional map types)
    };

    // Initialize the map
    const map = new Map(mapElement, mapOptions);

    if (isExact) {
        const marker = new Marker({
            map: map,
            position: { lat: latitude, lng: longitude },
            icon: {
                url: mapMarker,
                scaledSize: new google.maps.Size(60, 60),
            },
        });

        marker.addListener("click", () => {
            const googleMapsUrl = `https://www.google.com/maps/@${latitude},${longitude},${zoom}z`;
            window.open(googleMapsUrl, "_blank");
        });
    } else {
        const root = document.documentElement;
        const rootStyles = getComputedStyle(root);
        const fillColor = rootStyles.getPropertyValue("--slate");
        const strokeColor = fillColor;

        const circle = new Circle({
            map: map,
            center: { lat: latitude, lng: longitude },
            radius: 700,

            fillColor: fillColor,
            fillOpacity: 0.15,

            strokeColor: strokeColor,
            strokeOpacity: 0.5,
            strokeWeight: 1,
        });
    }
}

export default function initMaps() {
    const maps = document.querySelectorAll(".map:not(.on-demand)");

    if (maps.length > 0) {
        maps.forEach(initMap);
        if (DEBUG) console.log(`${maps.length} maps have been initialized.`);
    }
}
